/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import ChevronIcon from '@scandipwa/scandipwa/src/component/ChevronIcon';

import { LEFT } from 'Component/ChevronIcon/ChevronIcon.config';
import ContentWrapper from 'Component/ContentWrapper';
import { CHECKOUT_URL } from 'Route/Checkout/Checkout.config';
import {
    Breadcrumbs as SourceBreadcrumbs
} from 'SourceComponent/Breadcrumbs/Breadcrumbs.component';
import history from 'Util/History';
import { appendWithStoreCode, isHomePageUrl } from 'Util/Url';

import './Breadcrumbs.style';

// eslint-disable-next-line @scandipwa/scandipwa-guidelines/create-config-files
export const MENU_URL = '/menu';

/**
 * Breadcrumbs
 * @class Breadcrumbs
 * @namespace Scandipwa/Component/Breadcrumbs/Component
 */
export class BreadcrumbsComponent extends SourceBreadcrumbs {
    renderPdpBackButton() {
        const {
            urlRewrite,
            requestedUrl
        } = this.props;

        if (requestedUrl === location.pathname) {
            if (urlRewrite.type === 'PRODUCT') {
                return (
                    <div block="Breadcrumbs" elem="BackButton">
                        <button onClick={ history.goBack }>
                            <span>
                                <ChevronIcon direction={ LEFT } />
                            </span>
                            { __('back') }
                        </button>
                    </div>
                );
            }
        }

        return null;
    }

    // eslint-disable-next-line @scandipwa/scandipwa-guidelines/only-render-in-component
    shouldHideBreadcrumbs() {
        const { areBreadcrumbsVisible } = this.props;
        const { pathname = appendWithStoreCode('/') } = location;

        return (
            !areBreadcrumbsVisible
            || pathname.match(appendWithStoreCode(CHECKOUT_URL))
            || pathname.match(appendWithStoreCode(MENU_URL))
            || isHomePageUrl(pathname)
        );
    }

    render() {
        const { breadcrumbs } = this.props;

        if (this.shouldHideBreadcrumbs()) {
            return null;
        }

        return (
            <ContentWrapper mix={ { block: 'Breadcrumbs' } } label={ __('Breadcrumbs (current location)...') }>
                <nav aria-label="Breadcrumbs navigation" block="Breadcrumbs" elem="Nav">
                    <ul
                      block="Breadcrumbs"
                      elem="List"
                      itemScope
                      itemType="http://schema.org/BreadcrumbList"
                    >
                        { (
                            // eslint-disable-next-line @scandipwa/scandipwa-guidelines/jsx-no-conditional
                            breadcrumbs.length
                                ? this.renderBreadcrumbList(breadcrumbs)
                                : this.renderBreadcrumb({}, 0)
                        ) }
                    </ul>
                    { this.renderPdpBackButton() }
                </nav>
            </ContentWrapper>
        );
    }
}

export default BreadcrumbsComponent;
